import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { CountdownBar } from './components/CountdownBar';
import { RocketLaunch } from './components/RocketLaunch';
// Lazy load sections for performance
const ServicesSection = lazy(() => import('./components/ServicesSection').then(m => ({
  default: m.ServicesSection
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const BenefitsSection = lazy(() => import('./components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const FormulaSection = lazy(() => import('./components/FormulaSection').then(m => ({
  default: m.FormulaSection
})));
const MethodSection = lazy(() => import('./components/MethodSection').then(m => ({
  default: m.MethodSection
})));
const DemoSection = lazy(() => import('./components/DemoSection').then(m => ({
  default: m.DemoSection
})));
const SocialMediaSection = lazy(() => import('./components/SocialMediaSection').then(m => ({
  default: m.SocialMediaSection
})));
const SocialMediaPricingSection = lazy(() => import('./components/SocialMediaPricingSection').then(m => ({
  default: m.SocialMediaPricingSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
export function App() {
  useEffect(() => {
    document.title = 'Estrategias Digitales AZ';
    // Meta description
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'A‑Z convertimos ideas en presencia digital que genera clientes. Creamos páginas web profesionales a medida en tiempo récord.';
    // Open Graph tags (WhatsApp, Facebook, etc.)
    const ogTags: Record<string, string> = {
      'og:title': 'Estrategias Digitales AZ',
      'og:description': 'A‑Z convertimos ideas en presencia digital que genera clientes. Creamos páginas web profesionales a medida en tiempo récord.',
      'og:type': 'website',
      'og:image': 'https://cdn.magicpatterns.com/uploads/fdWnQMUp9fhE8KAVDmQakg/AZ_Logo_final_Colores.png'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
    // Meta Pixel
    if (!(window as any).fbq) {
      const f = window as any;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      f.fbq('init', '1243214431067357');
      f.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-[#050510] text-white selection:bg-purple-500 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <Suspense fallback={null} data-id="element-4">
          <ServicesSection data-id="element-5" />
          <ProblemSection data-id="element-6" />
          <BenefitsSection data-id="element-7" />
          <FormulaSection data-id="element-8" />
          <MethodSection data-id="element-9" />
          <DemoSection data-id="element-10" />
          <SocialMediaSection data-id="element-11" />
          <SocialMediaPricingSection data-id="element-12" />
          <TestimonialsSection data-id="element-13" />
          <PricingSection data-id="element-14" />
          <FAQSection data-id="element-15" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-16">
        <FooterSection data-id="element-17" />
      </Suspense>
      <RocketLaunch data-id="element-18" />
    </div>;
}